var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.deactivate,
          expression: "deactivate",
        },
      ],
      staticClass: "multiselect",
      class: {
        "multiselect--active": _vm.isOpen,
        "multiselect--disabled": _vm.disabled,
        "multiselect--above": !_vm.hasEnoughSpace,
      },
      attrs: { tabindex: _vm.searchable ? -1 : 0 },
      on: {
        focus: function ($event) {
          return _vm.activate()
        },
        blur: function ($event) {
          _vm.searchable ? false : _vm.deactivate()
        },
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            ) {
              return null
            }
            if ($event.target !== $event.currentTarget) {
              return null
            }
            $event.preventDefault()
            return _vm.pointerForward()
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            if ($event.target !== $event.currentTarget) {
              return null
            }
            $event.preventDefault()
            return _vm.pointerBackward()
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") &&
              _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
            ) {
              return null
            }
            $event.stopPropagation()
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.addPointerElement($event)
          },
        ],
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.deactivate()
        },
      },
    },
    [
      _vm._t("carret", [
        _c("div", {
          staticClass: "multiselect__select",
          on: {
            mousedown: function ($event) {
              $event.preventDefault()
              return _vm.toggle()
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "tags", staticClass: "multiselect__tags" },
        [
          _vm._l(_vm.visibleValue, function (option) {
            return _c(
              "span",
              {
                staticClass: "multiselect__tag",
                class: [{ readonly: option.readonly }, option.className],
                on: {
                  mousedown: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _vm._t(
                  "tag",
                  [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.getOptionLabel(option)),
                      },
                    }),
                  ],
                  { option: option }
                ),
                _vm._v(" "),
                !option.readonly
                  ? _c("i", {
                      staticClass: "multiselect__tag-icon",
                      attrs: { "aria-hidden": "true", tabindex: "1" },
                      on: {
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.removeElement(option)
                        },
                        mousedown: function ($event) {
                          $event.preventDefault()
                          return _vm.removeElement(option)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm.internalValue && _vm.internalValue.length > _vm.limit
            ? [
                _c("strong", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.limitText(_vm.internalValue.length - _vm.limit)
                    ),
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "multiselect__loading" } },
            [
              _vm._t("loading", [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "multiselect__spinner",
                }),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _vm.searchable
            ? _c("input", {
                ref: "search",
                staticClass: "multiselect__input",
                attrs: {
                  type: "text",
                  autocomplete: "off",
                  placeholder: _vm.placeholder,
                  disabled: _vm.disabled,
                },
                domProps: {
                  value: _vm.isOpen ? _vm.search : _vm.currentOptionLabel,
                },
                on: {
                  input: function ($event) {
                    return _vm.updateSearch($event.target.value)
                  },
                  focus: function ($event) {
                    $event.preventDefault()
                    return _vm.activate()
                  },
                  blur: function ($event) {
                    $event.preventDefault()
                    return _vm.blur()
                  },
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape",
                      ])
                    ) {
                      return null
                    }
                    return _vm.deactivate()
                  },
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.pointerForward()
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.pointerBackward()
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k(
                          $event.keyCode,
                          "enter",
                          13,
                          $event.key,
                          "Enter"
                        ) &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      return _vm.addPointerElement($event)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                          "Backspace",
                          "Delete",
                          "Del",
                        ])
                      ) {
                        return null
                      }
                      return _vm.removeLastElement()
                    },
                  ],
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.searchable
            ? _c("span", {
                staticClass: "multiselect__single",
                domProps: { textContent: _vm._s(_vm.currentOptionLabel) },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "multiselect" } }, [
        _c("div", { staticClass: "multiselect__content-wrapper" }, [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen",
                },
              ],
              ref: "list",
              staticClass: "multiselect__content",
              style: { maxHeight: _vm.maxHeight + "px" },
            },
            [
              _vm._t("beforeList"),
              _vm._v(" "),
              _vm.multiple && _vm.max === _vm.internalValue.length
                ? _c("li", [
                    _c(
                      "span",
                      { staticClass: "multiselect__option" },
                      [
                        _vm._t("maxElements", [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("profile.form.select_max_options", {
                                  max: _vm.maxChannels,
                                })
                              ),
                            },
                          }),
                        ]),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.max || _vm.internalValue.length < _vm.max
                ? _vm._l(_vm.filteredOptions, function (option, index) {
                    return _c(
                      "li",
                      { key: index, staticClass: "multiselect__element" },
                      [
                        !option.$isLabel
                          ? _c(
                              "span",
                              {
                                staticClass: "multiselect__option",
                                class: _vm.optionHighlight(index, option),
                                attrs: {
                                  tabindex: "0",
                                  "data-select": option.isTag
                                    ? _vm.tagPlaceholder
                                    : _vm.selectLabelText,
                                  "data-selected": _vm.selectedLabelText,
                                  "data-deselect": _vm.deselectLabelText,
                                },
                                on: {
                                  mousedown: function ($event) {
                                    $event.preventDefault()
                                    return _vm.select(option)
                                  },
                                  mouseenter: function ($event) {
                                    return _vm.pointerSet(index)
                                  },
                                },
                              },
                              [
                                _vm._t(
                                  "option",
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.getOptionLabel(option))
                                      ),
                                    ]),
                                  ],
                                  { option: option, search: _vm.search }
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        option.$isLabel
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "multiselect__option multiselect__option--disabled",
                                class: _vm.optionHighlight(index, option),
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.$groupLabel) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.filteredOptions.length === 0 &&
                        _vm.search &&
                        !_vm.loading,
                      expression:
                        "filteredOptions.length === 0 && search && !loading",
                    },
                  ],
                },
                [
                  _c(
                    "span",
                    { staticClass: "multiselect__option" },
                    [
                      _vm._t("noResult", [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("profile.form.select_no_results"))
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._t("afterList"),
            ],
            2
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }